import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import 'prop-types';
import warning from 'warning';
const IS_DEV = process.env.NODE_ENV !== 'production';
const warn = function () {
  if (IS_DEV) {
    warning(...arguments);
  }
};
const VppContext = /*#__PURE__*/React.createContext();
const {
  Provider,
  Consumer: VppConsumer
} = VppContext;
const VppProvider = _ref => {
  let {
    children,
    staticProps,
    loadableIcon,
    dependencies,
    icons
  } = _ref;
  return /*#__PURE__*/_jsx(Provider, {
    value: {
      staticProps,
      loadableIcon,
      dependencies,
      icons
    }
  }, void 0, children);
};
const useVppContext = () => {
  const context = React.useContext(VppContext);
  if (!context) {
    warn(false, `VppProvider is not declared. Make sure you add it to the root of your page`);
    return null;
  }
  return context;
};
const WithVppContext = Component => {
  const VppContextWrapper = props => /*#__PURE__*/_jsx(VppConsumer, {}, void 0, value => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    vppContext: value
  })));
  VppContextWrapper.displayName = 'WithVppContext';
  return VppContextWrapper;
};
export { VppConsumer, VppContext, VppProvider, WithVppContext, useVppContext };
